import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AccessDenied from './AccessDenied';
import { base_url } from '../api/index';
import { useI18n } from '../i18n/I18nContext';

const getHeaders = () => ({
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

function MasaDegistir({ tableItemData, onDone }: { tableItemData: any; onDone?: () => void }) {
    const { t } = useI18n();
    const [availableTables, setAvailableTables] = useState<any[]>([]);
    const [selectedTable, setSelectedTable] = useState('');
    const [accessDenied, setAccessDenied] = useState(false); 
    useEffect(() => {
        const fetchAvailableTables = async () => {
            try {
                const response = await axios.get(`${base_url}/tables`, {
                    ...getHeaders(),
                    params: {
                        is_available: 1
                    },
                });
                
                // Filter out the current table from the available tables
                const filteredTables = response.data.tables.filter(table => table.id !== tableItemData.id);
                setAvailableTables(filteredTables);
            } catch (error: any) {
                console.error('Error fetching available tables:', error);
            }
        };

        fetchAvailableTables();
    }, [tableItemData.id]);

    const handleChangeTable = async (event) => {
        event.preventDefault();
        if (selectedTable) {
            try {
                await axios.post(`${base_url}/tables/${tableItemData.id}/change-table`, {
                    table_id: selectedTable
                }, getHeaders());
                
                // Handle successful response if needed
                // alert('Table changed successfully!');
                // Tam səhifə yeniləməsi POS-da 1-3 saniyə ağ ekran deməkdir.
                // Masa grid-i onsuz da realtime-dır — pos_local WS
                // "orders.OrderTableChanged" yayır, ona görə modalı bağlamaq bəsdir.
                if (onDone) onDone();
                else window.location.reload();
            } catch (error: any) {
                if (error.response && error.response.status === 403 && error.response.data.message === "Forbidden") {
                    setAccessDenied(true); // Set access denied if response status is 403
                } else {
                   
                    console.error('Error changing table:', error);
                    alert(t('modal.changeTableError'));
                }
            }
        } else {
            // alert('Please select a table.');
        }
    };

    if (accessDenied) return <AccessDenied onClose={setAccessDenied}/>;
    return (
        <form onSubmit={handleChangeTable}>
            <div className='border rounded bg-gray-50 m-4 p-3'>
                <h3 className='mb-3'>{t('modal.changeTableTitle')}</h3>
                <div className='flex items-center mb-3'>
                    <select
                        className='form-item w-full'
                        name="targetTable"
                        id="targetTable"
                        value={selectedTable}
                        onChange={(e) => setSelectedTable(e.target.value)}
                        required
                    >
                        <option value="">{t('modal.selectTable')}</option>
                        {availableTables.map(table => (
                            <option key={table.id} value={table.id}>
                                {table.name || t('modal.noName')}
                            </option>
                        ))}
                    </select>
                </div>
                <button type="submit" className='block bg-sky-600 font-medium py-2 px-4 rounded text-white'>
                    {t('modal.changeTable')}
                </button>
            </div>
        </form>
    );
}

export default MasaDegistir;


